import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { defaultPageInfo, defaultPaging } from '@/common/constants/ConstCode';

const state = {
  condition: {
    ...defaultPaging,
    userNo: ''
  },
  pageInfo: {
    ...defaultPageInfo
  },
  notificationList: [],
  detail: '',
  // 260506: 메인 헤더 종 아이콘 뱃지에 표시할 미열람 개수.
  unreadCount: 0
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
